import { render } from "./SingelOrderBackBtn.vue?vue&type=template&id=8d912244&scoped=true"
import script from "./SingelOrderBackBtn.vue?vue&type=script&lang=js"
export * from "./SingelOrderBackBtn.vue?vue&type=script&lang=js"

import "./SingelOrderBackBtn.vue?vue&type=style&index=0&id=8d912244&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d912244"]])

export default __exports__